import React, {useEffect} from 'react'
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {connect, useSelector} from "react-redux";
import { Card, CardBody, CardTitle } from "reactstrap";


// components
import AppRequestLogFilters from "./_filters";
import AppRequestLogForm from "./_form";
import { ModalFormContainer } from "../../../components/confirmAlert/ModalFormContainer";
import { GenericTableButton} from "../../../components/buttons/buttonsActions";

// labels
import {
    LIST,
    NO_DATA_FOUND, VIEW_DETAIL,
} from "../../../components/i18n/i18n";

// actions
import {appRequestLogService} from "../../../jwt/_services/monitor/AppRequestLogService";
import {mapFunctions} from "../../../components/map/mapFunctions";
import {utilHelper} from "../../../jwt/_helpers";
import Moment from "moment/moment";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {setForm, setItem, setLoading, setViewMode, setFilter, setTableParams} from "../../../redux/actions/generics/IndexedActions";

// services


const AppRequestLogList = props => {
    // const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps

    const componentState = useSelector(state => getStateByPath(state, props.path));

    const { path } = componentState;
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = componentState?.data;

    // asignar los valores por default del filtro
    useEffect( () => {
        if( filter )
            return

        props.setFilter(path , {
            from: utilHelper.formatDateToString(Moment().subtract(2, 'minutes').toDate(), 'YYYY-MM-DD HH:mm:ss'),
            to: utilHelper.formatDateToString(new Date(), 'YYYY-MM-DD HH:mm:ss')
        } )
    }, [ ]);

    // realizar búsqueda cuando cambie el filtro
    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, appRequestLogService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter ]);

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams(path , tableChangeParams.sizePerPage, currentIndex );
    };

    const editItem = (data) => {
        try {
            // void reading null elements
            if (data?.response){
                const jsonResponse = JSON.parse( data?.response )
                const jsonRequest = JSON.parse( data?.request )

                let _center = null
                if (jsonResponse?.response?.points !== null && jsonResponse?.response?.points.length > 2)
                    _center = mapFunctions.getMidElement( jsonResponse?.response?.points || [] );
                else
                    _center = jsonRequest?.body?.pointA;

                props.setForm(path, true, false, false);
                props.setItem(path, data);
                ModalFormContainer(AppRequestLogForm, { path, data, Form: AppRequestLogForm, center: _center })
            } else {
                props.setForm(path, true, false, false);
                props.setItem(path, data);
                ModalFormContainer(AppRequestLogForm, { path, data, Form: AppRequestLogForm })
            }
        } catch (e) {
            console.error("Error al editar el item", e);
            return;
        }
    }

    const actionsFormatter = (cell, row) => <>
        <GenericTableButton toolTip={VIEW_DETAIL} icon={'fa-eye'} permission={'edit'} onClick={() => editItem(row)}/>
    </>

    const dateFormatter = (cell) => utilHelper.datetimeFormatter(cell)

    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'registerDate',
            text: 'Fecha de registro',
            headerStyle: {width: '180px'},
            formatter: dateFormatter
        }, {
            dataField: 'app',
            text: 'APP',
            headerStyle: {width: '180px'},
        }, {
            dataField: 'method',
            text: 'Metodo',
            headerStyle: {width: '180px'},
        }, {
            dataField: 'activityName',
            text: 'Actividad',
            align: 'left'
        }, {
            dataField: 'executionTime',
            text: 'Tiempo de ejecución (milisegundos)',
            headerStyle: {width: '120px'},
            align: 'right'
        }, {

            dataField: 'responseStatus',
            text: 'Status',
        }, {
            isDummyField: true,
            text: 'Acción',
            headerStyle: {width: '120px'},
            formatter: actionsFormatter
        }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"> </i>{LIST}
        </CardTitle>

        <AppRequestLogFilters path={path} />

        <CardBody className="">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    setLoading,
})

export default connect(mapStateToProps, mapActionsToProps)(AppRequestLogList)